const getDuration = (value) => {
    const secNum = parseInt(value, 10);
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor((secNum - (hours * 3600)) / 60);
    return `${hours} hr ${minutes} min`;
};

export default getDuration;
